import { render, staticRenderFns } from "./host-supply-task.vue?vue&type=template&id=d8d95efc&scoped=true&"
import script from "./host-supply-task.vue?vue&type=script&lang=js&"
export * from "./host-supply-task.vue?vue&type=script&lang=js&"
import style0 from "./host-supply-task.vue?vue&type=style&index=0&id=d8d95efc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d95efc",
  null
  
)

export default component.exports